import { render, staticRenderFns } from "./multiMarketplace.vue?vue&type=template&id=94602898&scoped=true"
import script from "./multiMarketplace.vue?vue&type=script&lang=js"
export * from "./multiMarketplace.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94602898",
  null
  
)

export default component.exports